var map = {
	"./codeanywhere.png": 396,
	"./codementor.png": 397,
	"./codewars.png": 398,
	"./crowdcast.png": 399,
	"./devprotocol.png": 400,
	"./dfinity.png": 401,
	"./ga.png": 402,
	"./hackerrank.png": 403,
	"./hashgraph.png": 404,
	"./hired.png": 405,
	"./hyperledger.png": 406,
	"./infoq.png": 407,
	"./joseph.png": 408,
	"./kadena.png": 409,
	"./keep.png": 410,
	"./kitties.png": 411,
	"./monero.png": 412,
	"./multicoin.png": 413,
	"./nucypher.png": 414,
	"./orchid.png": 415,
	"./origin.png": 416,
	"./parity.png": 417,
	"./pluralsight.png": 418,
	"./stronghold.png": 419,
	"./thunder.png": 420,
	"./topcoder.png": 421,
	"./toptal.png": 422
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 395;


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/partners nonrecursive \.(png|jpe?g|svg)$
// module id = 395
// module chunks = 0